import React from 'react';
import heart from '../../assets/heart.svg';
import picD from '../../assets/pic.webp';
import picT from '../../assets/pic-t.webp';
import picM from '../../assets/pic-m.webp';

const Hero = () => {
  return (
    <section id='top'>
      <div className='container tc'>
        <div className='s-40 sm-60'></div>
        <h1 className='title-intro'>
          Курси вайб-кодінгу для <img src={heart} alt='Серце' width={60} height={54} />{' '}
          українців
        </h1>
        <div className='s-24'></div>
        <h3 className='title-intro-sub w-60 ma'>
          Хочете в IT, але не вмієте програмувати?<br />

          Ми вас навчимо писати код за допомогою ШІ!
        </h3>
        <div className='s-32'></div>
        <a href='/ua' className='button'>
          Почати навчання
        </a>
        <div className='s-32'></div>
        <p className='title-mini'>
          Наші онлайн курси безкоштовні
        </p>
        <div className='s-48'></div>
        <img
          src={picD}
          alt='Курси'
          width={1118}
          height={600}
          className='show-d'
        />
        <img
          src={picT}
          alt='Курси'
          width={940}
          height={504}
          className='show-t'
        />
        <img
          src={picM}
          alt='Курси'
          width={572}
          height={307}
          className='show-m'
        />
        <div className='s-48'></div>
      </div>
      <div className='back'></div>
    </section>
  );
};

export { Hero }; 